import { render, staticRenderFns } from "./TabelaFreteRotaModal.vue?vue&type=template&id=48dc3dce"
import script from "./TabelaFreteRotaModal.vue?vue&type=script&lang=js"
export * from "./TabelaFreteRotaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports